// Special user email that has access to registration functionality
export const SPECIAL_USER_EMAIL = 'pupkin2600@mail.ru'.toLowerCase();
